import { createContext, useContext } from 'react';
/**
 * Lets a form modal know the user changed something (used for the
 * "Discard changes?" prompt). EnhancedFormModal provides it; fields whose
 * changes don't fire a native change event (react-select) call it themselves.
 */
export const FormDirtyContext = createContext(null);
export const useMarkFormDirty = () => useContext(FormDirtyContext);
